import { CSVEntityItem } from './CSVEntityItem'

export const ConcreteMixDesign = new CSVEntityItem({
  id: 'FBD89FD1-094D-43F0-8855-938CF7C46A07',
  queryParameter: 'concrete-mix-design',
  headers: [
    'Global ID',
    'Status',
    'Admixtures',
    'Aggregates',
    'Air Range',
    'Class',
    'Use',
    'Expiration Date',
    'Supplier',
    'Max Agg Size',
    'Mix ID',
    'Slump Range',
    'Submittal ID',
    'W/C Ratio',
    'customFields',
  ],
  classType: 'ConcreteMixDesign',
  classTypeName: 'Concrete Mix Design',
  filtered: true,
})
export const DesignSubmittal = new CSVEntityItem({
  id: '1162BAB1-3FA4-464F-904D-FEE07DCE3F65',
  queryParameter: 'design-submittal',
  headers: [
    'Creation Date',
    'Status',
    'External Links',
    'Package Number',
    'Package Name',
    'Type',
    'Disciplines',
    'Actions',
    'Submitted By',
    'Submitted Organizations',
    'Submitted Date',
    'Requested Action Date',
    'Contract Due Date',
    'Disposition',
    'Disposition Date',
    'Disposition By',
    'Pay Items',
    'Comments',
    'ID',
  ],
  classType: 'DesignSubmittal',
  classTypeName: 'Design Submittal',
  filtered: true,
})
export const ConstructionAdminSubmittal = new CSVEntityItem({
  id: 'D9FE5B1E-772F-4896-866F-FB33607024FE',
  queryParameter: 'construction-admin-submittal',
  headers: [
    'Status',
    'Routing Groups',
    'External Links',
    'Package Number',
    'Package Name',
    'Type',
    'Subtype',
    'Quantity',
    'Units',
    'User',
    'Created Date',
    'Requested Review Date',
    'Contract Date',
    'Disposition',
    'Disposition Date',
    'Pay Items',
    'Comments',
    'customFields',
  ],
  classType: 'ConstructionAdminSubmittal',
  classTypeName: 'Construction & Admin Submittal',
  filtered: true,
})
export const FieldDesignChanges = new CSVEntityItem({
  id: '62B488AD-5CA3-42D3-81FC-ED27FFF7CAA4',
  queryParameter: 'field-design-changes',
  headers: [
    'Number',
    ' Status',
    'Concurrence Level Name',
    'Concurrence Level Description',
    'Location',
    'Drawings Affected',
    'Issue',
    'Resolution',
    'Submitted By',
    'Date Submitted',
    'Comments',
    'customFields',
    'Requested Approval Date',
    'Concurrence By',
    'Date Concurred',
    'Approval By',
    'Date Approved',
    'Created Date',
    'Deleted User',
    'Deleted Date',
    'Project ID',
    'Pay Items',
  ],
  classType: 'FieldDesignChange',
  classTypeName: 'Field Design Change',
})
export const IdentifiedFieldIssue = new CSVEntityItem({
  id: '9D33BCF3-8D9D-4CD6-93D0-42BE5A66CCA1',
  queryParameter: 'identified-field-issue',
  headers: [
    'Status',
    'Report ID',
    'Report Type',
    'Report Review Status',
    'Report Date',
    'Suggested Issue Types',
    'Issue Description',
    'Reviewed By',
    'Review Notes',
    'Issue Review Date',
    'Comments',
    'customFields',
  ],
  classType: 'IdentifiedFieldIssue',
  classTypeName: 'Identified Field Issue',
})
export const Issue = new CSVEntityItem({
  id: 'B992AEA1-5EE3-438A-8DE7-2287529A575E',
  queryParameter: 'issue',
  headers: [
    'Status',
    'Item Number',
    'Identified Field Issue',
    'Reports',
    'Types',
    'Description',
    'Submitted By',
    'Submitted Date',
    'Response',
    'Response By',
    'Response Date',
    'Disposition',
    'Disposition Notes',
    'Disposition By',
    'Disposition Date',
    'Closure Notes',
    'Closed By',
    'Closed Date',
    'Pay Items',
    'Comments',
    'customFields',
    'Deleted By',
    'Deleted Date',
  ],
  classType: 'Issue',
  classTypeName: 'Issue',
})
export const RequestForInformation = new CSVEntityItem({
  id: '70351CB5-8AF5-4487-B027-9727DE2E06E0',
  queryParameter: 'request-for-information',
  headers: [
    'Number',
    'Status',
    'Description',
    'Organization',
    'Requested Response Date',
    'Response Disciplines',
    'Submitted By',
    'Date Submitted',
    'Closed Date',
    'Comments',
    'customFields',
    'Created Date',
    'Deleted User',
    'Deleted Date',
    'Project ID',
  ],
  classType: 'RequestForInformation',
  classTypeName: 'Request For Information',
})
export const AsphaltMixDesign = new CSVEntityItem({
  id: 'A681B970-D4E8-4EF4-A70D-56106BD5A8F1',
  queryParameter: 'asphalt-mix-design',
  headers: [
    'Status',
    'Mix ID',
    'Supplier',
    'Nominal Size',
    'Binder Grade',
    'Design Builder Content',
    'VMA',
    'Theoretical Max Specific Gravity',
    'Targets',
    'Specific Gravity of Aggregate',
    'Material Source',
    'Expiration Date',
    'Max Aggregate Size',
    'customFields',
  ],
  classType: 'AsphaltMixDesign',
  classTypeName: 'Asphalt Mix Design',
})
export const PayItemNoGeometry = new CSVEntityItem({
  id: 'CFEC47A8-2D1B-4CDE-BFFD-8AAD4A71FD82',
  queryParameter: 'pay-item-no-geometry',
  headers: [
    'createdDate',
    'createdUser',
    'deleted',
    'description',
    'globalId',
    'label',
    'lastEditedDate',
    'lastEditedUser',
    'materialGuid',
    'payItemId',
    'projectId',
    'status',
  ],
  importColumns: ['globalId', 'payItemId', 'description', 'deleted'],
  upsertKeys: ['payItemId', 'globalId'],
  classType: 'PayItemNoGeometry',
  classTypeName: 'Pay Item',
})
